module.exports = __webpack_public_path__ + "img/75640.1cc9fbf0.svg";